(function() {
  const newsSliders = document.querySelectorAll('.voo-news-slider__slider-wrapper');
  let matchMedia = window.matchMedia('(max-width: 639px)');

  if (newsSliders.length == 0) return;

  function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  newsSliders.forEach((news) => {
    news.addEventListener('click', (event) => {
      if (
        matchMedia.matches
        && event.target.classList.contains('voo-news-slider__content-text--btn')
        || event.target.closest('.voo-news-slider__content-text--btn')
      ) {
        const textContentWrapper = event.target.closest('.voo-news-slider__content-text');
        const textContent = textContentWrapper?.querySelector('.voo-news-slider__content-text-wrapper');

        textContentWrapper?.classList.toggle('active');

        if (!textContent || !textContentWrapper) return;

        if (textContentWrapper.classList.contains('active')) {
          const fullContent = textContentWrapper.querySelector('.voo-news-slider__content-full-text');
          textContent.innerHTML = fullContent?.innerHTML;
        } else {
          const truncateContent = textContentWrapper.querySelector('.voo-news-slider__content-truncate-text');
          textContent.innerHTML = truncateContent?.innerHTML;
        }
      }
    });
  });

  function checkingMatchMedia(matches) {
    const contentTextEls = document.querySelectorAll('.voo-news-slider__content-text');

    if(contentTextEls.length == 0) return;

    if (matches) {
      contentTextEls.forEach((element) => {
        if (element.querySelector('.voo-news-slider__content-truncate-text')) {
          element.classList.remove('hide-truncate');
        }
      });
    } else {
      contentTextEls.forEach((element) => {
        if (element.querySelector('.voo-news-slider__content-truncate-text')) {
          element.classList.add('hide-truncate');
        }
      });
    }
  }

  function changeMatchMedia() {
    matchMedia = window.matchMedia('(max-width: 639px)');
    checkingMatchMedia(matchMedia.matches);
  }

  checkingMatchMedia(matchMedia.matches);
  window.addEventListener('resize', debounce(() => changeMatchMedia(), 400));
})();
